<template>
  <div id="pc" class="redBg">
    <sideBar></sideBar>
    <header class="whiteBg">
      <div class="headerInfo content">
        <div class="infoBlock inlBlock" @click="moveTo(siteUrl)">
          <img src="../assets/img/pc/logo.png" alt="logo" />
          <div class="inlBlock">
            <p class="mr0">彩世界</p>
            <span>{{ siteUrl }}</span>
          </div>
        </div>
        <div class="secInfoBlock inlBlock">
          <p class="mr0">· 千万人都在用的彩票数据分析和聊天室应用平台</p>
        </div>
      </div>
    </header>
    <div class="detailWrap">
      <div class="detailContent">
        <div class="lotteryBlock">
          <div class="lotteryInfo inlBlock b70">
            <img
              class="logo"
              :src="require(`../assets/img/` + pathId + `Logo.png`)"
              :alt="pathId + 'logo'"
            />
            <div class="info inlBlock">
              <h2>{{ title }}</h2>
              <p>{{ shortDesc }}</p>
              <ul class="lotteryInfolList">
                <li>大小：23MB</li>
                <li>下载：117.2万</li>
                <li>版本：4.8.0</li>
                <li>更新：2019-09-1</li>
              </ul>
            </div>
            <div class="downloadInfo inlBlock">
              <!-- <span class="downloadTitle inlBlock">内幕资料</span>
              <p>
                <span class="inlBlock">免费精准资料，领取三肖3码</span>
                <img :src="require(`../assets/img/pc/line.png`)" alt="line" />
                <span class="inlBlock">内幕专员</span>
                <span class="link" @click="onGotoChat">点击立即领取</span>
              </p> -->
              <span class="downloadTitle inlBlock">手机快捷下载通道</span>
              <p>
                <span class="inlBlock"> 手机扫描二维码快速下载 </span>
                <img :src="require(`../assets/img/pc/line.png`)" alt="line" />
                <span class="inlBlock"> 用手机浏览器输入网址 </span>
                <span class="link">{{ siteUrl }}</span>
              </p>
            </div>
          </div>
          <div class="bannerContent">
            <p class="mr0">应用介绍</p>
            <div
              data-simplebar=""
              data-simplebar-auto-hide="false"
              class="banner red bottom22"
            >
              <ul
                ref="bannerList"
                :class="
                  pathId == 'caishijie' ? 'bannerList border' : 'bannerList'
                "
                :style="{ width: returnSlideW * slides + 140 + 'px' }"
              >
                <li v-for="(slide, i) in slides" :key="i">
                  <img
                    :src="
                      require(`../assets/img/moblie/` +
                        pathId +
                        `/banner${slide}.png`)
                    "
                    alt="banner"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="qrCodeContent inlBlock">
          <div class="qrCodeWrap inlBlock">
            <qrcode-vue
              :value="currentUrl"
              class="qrcodeImg"
              :size="180"
              level="H"
            ></qrcode-vue>
          </div>
          <p>手机扫描二维码下载</p>
        </div>
      </div>
      <div class="detailInfo">
        <h2>应用介绍</h2>
        <p class="info">
          <template v-if="desc !== '' && desc !== undefined">
            {{ desc }}<br />
            【特色服务】<br />
            <span v-for="(item, index) in features" :key="index">
              ★{{ item.title }}<br />
              <span v-for="(fe, idx) in item.items" :key="idx + 20">
                - {{ fe }}<br />
              </span>
            </span>
          </template>
          <template v-else>
            {{ info }}
          </template>
        </p>
      </div>
    </div>
    <div id="bottom" class="bwbg whiteBg">
      <div class="bottomInfo">
        <p>一机在手，多功能应用，你值得拥有！</p>
        <p class="mr0">快去下载吧！</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped >
@import "../assets/style/pc.scss";
</style>
<script>
import QrcodeVue from "qrcode.vue";
import sideBar from "@/components/sideBar";
import { getUrlKey, isKeyEmpty } from "../utils/urltool";
export default {
  name: "pcDetail",
  components: {
    QrcodeVue,
    sideBar,
  },
  data() {
    return {
      pathId: "caishijie",
      slides: 6,
      slideW: 310,
      title: "",
      shortDesc: "",
      info: "",
      siteUrl: "",
      currentUrl: "",
      downChannel: undefined,
      desc: undefined,
      features: undefined,
    };
  },
  computed: {
    returnSlideW: function () {
      return this.slideW;
    },
  },
  mounted() {
    let url = window.location.href;
    let urlArr = url.split("/");
    let result = urlArr[urlArr.length - 1].split(".");
    this.pathId = result[0];
    this.downChannel = getUrlKey("channel", url);
    this.title = this.$store.getters.returnTitle(this.pathId);
    this.shortDesc = this.$store.getters.returnShortDesc(this.pathId);
    this.info = this.$store.getters.returnInfo(this.pathId);
    this.desc = this.$store.getters.returnDesc(this.pathId);
    this.features = this.$store.getters.returnFeatures(this.pathId);
    this.currentUrl = url;
    var _this = this;
    setTimeout(function () {
      _this.siteUrl = window.siteUrl;
    }, 500);
  },
  methods: {
    moveTo(path) {
      let url = new URL(window.location.href)
      let searchParams = isKeyEmpty(url.search) ? "" : url.search;
      window.location.href = "http://" + path + searchParams;
    },
    onGotoChat() {
      window.open(this.$store.state.chatTokent);
    }
  },
};
</script>

